import { graphql } from "../gql";

export const getAskAutodorFileVectorsExistQueryDoc = graphql(`
  query getAskAutodorFileVectorsExistQuery(
    $input: AskAutodorFileVectorsExistInput
  ) {
    askAutodorFileVectorsExist(input: $input) {
      documentIds
    }
  }
`);
